export default {
  // GREEN
  green1: '#17BD5E',
  green2: '#2CDA78',
  green3: '#52DC8E',
  green4: '#80E5AC',
  green5: '#B5F0CE',
  green6: '#DAFFEA',

  // ORANGE
  orange1: '#FF7829',
  orange2: '#fd8a47',
  orange3: '#FFA976',
  orange4: '#FFC19D',
  orange5: '#FFD9C3',
  orange6: '#FFEFE5',

  // RED
  red1: '#FF4343',
  red2: '#FC5757',
  red3: '#FD8181',
  red4: '#FEABAB',
  red5: '#FED5D5',
  red6: '#FFEAEA',

  // BLACK
  black1: '#393E50',
  black2: '#616573',
  black3: '#888B96',
  black4: '#B0B2B9',
  black5: '#D0D1D5',
  black6: '#EBECED',
  black7: '#000000',

  // WHITE
  white: '#ffffff',

  // PURPLE
  purple1: '#6055CD',
  purple2: '#7870CE',
  purple3: '#938DD8',
  purple4: '#A9A4E0',
  purple5: '#C8C5EB',
  purple6: '#E5E3F5',

  // GREY
  grey1: '#D2D8DB',
  grey2: '#EDF4F6',
  grey3: '#F3F7F9',
  grey4: '#FAFCFD',
  grey5: '#FFFFFF',

  // BLUE 1
  blue1: '#197A98',
  blue7: '#D5F0F8',
};
